import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

class ChapterContent extends Component {
  render() {
    const { content, name, index } = this.props;
    return (
      <div className="chapter-content">
        <div className="container -horizon-padding">
          <h1>{index}. {name}</h1>
          <div className="" dangerouslySetInnerHTML={{__html: content}}></div>
        </div>
      </div>
    );
  }
}

export default ChapterContent;



// WEBPACK FOOTER //
// ./src/components/ChapterContent/pure.js